
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.875 15.125A2.893 2.893 0 013 13H.5l.45-2h2.825a3 3 0 011-.738A2.915 2.915 0 016 10c.433 0 .842.088 1.225.262a3 3 0 011 .738H12.4l2.1-9H5.55l.425-2H17l-.925 4H19l3 4-1 5h-2c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0116 16a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 0113 13H9c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 016 16a2.893 2.893 0 01-2.125-.875zM14.925 9h4.825l.1-.525L18 6h-2.375l-.7 3zM14.5 2l-2.1 9 .05-.175L14.5 2zm-12 7V6H0l3.5-5v3H6L2.5 9zM6 14c.283 0 .52-.096.713-.287A.968.968 0 007 13a.968.968 0 00-.287-.713A.967.967 0 006 12a.967.967 0 00-.713.287A.968.968 0 005 13c0 .283.096.52.287.713.192.191.43.287.713.287zm10 0c.283 0 .52-.096.712-.287A.968.968 0 0017 13a.968.968 0 00-.288-.713A.968.968 0 0016 12a.968.968 0 00-.713.287A.968.968 0 0015 13c0 .283.096.52.287.713.192.191.43.287.713.287z","fill":"#304F1A"}})])
          )
        }
      }
    